import {
  TEntityResponse,
  TEntityListResponse,
  TCreateClientReqBody,
  TClientResBody,
  TClientSummaryResBody,
  TUpdateClientReqBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TClientsClient = {
  create(body: TCreateClientReqBody): Promise<TEntityResponse<'client', TClientResBody> | undefined>;
  update(id: string, body: TUpdateClientReqBody): Promise<TEntityResponse<'client', TClientResBody> | undefined>;
  delete(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'client', TClientResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'client', TClientSummaryResBody> | undefined>;
};

function ClientsClient(apiClient: TAPIClient): TClientsClient {
  return {
    async create(body: TCreateClientReqBody): Promise<TEntityResponse<'client', TClientResBody> | undefined> {
      const data = await apiClient.post<TCreateClientReqBody, TEntityResponse<'client', TClientResBody>>(
        `/clients`,
        body
      );

      if (data && data.type !== 'client') {
        throw new Error('Invalid entity type received, expected: client, received: ' + data.type);
      }

      return data;
    },

    async update(
      id: string,
      body: TUpdateClientReqBody
    ): Promise<TEntityResponse<'client', TClientResBody> | undefined> {
      const data = await apiClient.put<TUpdateClientReqBody, TEntityResponse<'client', TClientResBody>>(
        `/clients/${id}`,
        body
      );

      if (data && data.type !== 'client') {
        throw new Error('Invalid entity type received, expected: client, received: ' + data.type);
      }

      return data;
    },

    async delete(id: string): Promise<void> {
      return await apiClient.delete(`/clients/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'client', TClientResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'client', TClientResBody>>(`/clients/${id}`);

      if (data && data.type !== 'client') {
        throw new Error('Invalid entity type received, expected: client, received: ' + data.type);
      }

      return data;
    },

    async list(limit: number, page: number): Promise<TEntityListResponse<'client', TClientSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'client', TClientSummaryResBody>>(
        `/clients?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'client') {
        throw new Error('Invalid entity type received, expected: client, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TClientsClient, ClientsClient };
